export class Lotacao {
    id: string;

    constructor() {}
}
